import React, { lazy, Suspense, useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "./Component/Common/Loader";
import Header from "./Component/Element/Header";
import Footer from "./Component/Element/Footer";

import { useEffect } from "react";
const MainPage = lazy(() => import("./MainPage"));
const GA_TRACKING_ID = "G-7QFQ19RQ45"; // OUR_TRACKING_ID

// gtag.js is loaded globally from public/index.html; useLocation only works
// inside <BrowserRouter>, so this must be a child of it, not App itself.
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV === "production" && window.gtag) {
      window.gtag("config", GA_TRACKING_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

const App = (props) => {
  const [gameMenuLink, setGameMenuLink] = useState("gamemenu-link");
  const [gameMenuOverlay, setGameMenuOverlay] = useState("gamemenu-overlay");

  const removeGameMenu = () => {
    setGameMenuLink("gamemenu-link");
    setGameMenuOverlay("gamemenu-overlay");
  };

  const gameMenuClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setGameMenuLink("gamemenu-link open");
    setGameMenuOverlay("gamemenu-overlay active");
  };

  const handleDocumentClick = (event) => {
    const gameMenu = document.getElementById("gamemenu");
    if (gameMenu && !gameMenu.contains(event.target)) {
      removeGameMenu();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  return (
    <BrowserRouter>
      <RouteTracker />
      <ToastContainer />

      <Suspense fallback={<Loader />}>
        <Header />
        <MainPage
          gameMenuLink={gameMenuLink}
          gameMenuOverlay={gameMenuOverlay}
          gameMenuClick={gameMenuClick}
          removeGameMenu={removeGameMenu}
        />
        <Footer
          gameMenuLink={gameMenuLink}
          gameMenuOverlay={gameMenuOverlay}
          gameMenuClick={gameMenuClick}
          removeGameMenu={removeGameMenu}
        />
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
